





























































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component
export default class ComponentBackofficeReserva extends Vue {
  headers: any[] = [
    { text: 'Hemocomponente', class: 'table-headers-email', align: 'left', value: 'display', sortable: false },
    { text: 'Qtd', class: 'table-headers-email', align: 'left', value: 'quantidade', sortable: false },
  ]

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getEquipamentos() {
    return this.getBackofficeGlobalStore.solicitacao.equipamentos
  }

  get getCaixasCirurgicas() {
    return this.getBackofficeGlobalStore.solicitacao.caixasCirurgicas || []
  }

  get getReservaHemocomponentes() {
    return (this.getBackofficeGlobalStore.solicitacao.reservaHemocomponentes.concentradoHemacias)
      ? []
      : this.getBackofficeGlobalStore.solicitacao.reservaHemocomponentes
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]
      if (response) return response.habilitado
    }

    return false
  }
}
